export default __webpack_public_path__ + "static/media/linkswap.ad00ced7.jpg";